import { graphQlClient } from "lib/graphql-client.js";
import Layout from "components/Layout";

import dynamic from "next/dynamic";

import PageIntro from "components/content/PageIntro/PageIntro";
const CharityCard = dynamic(() => import("components/card/CharityCard"));

const ImpactArea = dynamic(() => import("components/AboutPage/ImpactArea"));
const OurValues = dynamic(() => import("components/AboutPage/OurValues"));
const OurStory = dynamic(() => import("components/AboutPage/OurStory"));

import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";

import styles from "./about.module.scss";
import { aboutPageQuery } from "lib/graphql/about-queries";

const About = ({ aboutData, introData, layoutData }) => {
  const SEO = aboutData?.search_engine_optimization;

  return (
    <>
      <Layout seo={SEO} layoutData={layoutData}>
        <div className={`${styles.about}`}>
          {aboutData?.page_intro && (
            <div
              className={`${styles.valueArea}`}
              style={{ paddingBottom: "0", paddingTop: "0" }}
            >
              <div className={`variable-container`}>
                <PageIntro
                  title={aboutData?.page_intro?.page_title}
                  description={aboutData?.page_intro?.page_introduction}
                  // image={aboutData?.page_intro?.intro_photo}
                  layout="imageRight"
                />
              </div>
            </div>
          )}
        </div>
        <div>
          <OurValues about={aboutData?.ourValues} />

          <ImpactArea about={aboutData?.ourImpact} />

          <div className="spacer" />

          <CharityCard
            charityData={aboutData?.charitySlider?.charities}
            charityHeader={aboutData?.charitySlider?.charityHeader}
          />

          <div className="ourStoryArea">
            <div className="container">
              <OurStory about={aboutData?.ourStory} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};
export default About;

export async function getStaticProps() {
  const { default: MarkdownIt } = await import("markdown-it");

  const md = new MarkdownIt();
  const strapiApolloClient = graphQlClient();

  const { data } = await strapiApolloClient.query({
    query: aboutPageQuery,
  });

  const aboutAttributes = data?.about?.data?.attributes;

  const aboutData = {
    ...aboutAttributes,
    ourStory: {
      ...aboutAttributes?.ourStory,
      ourStoryTextPart1: md.render(
        aboutAttributes?.ourStory?.ourStoryTextPart1
      ),
      ourStoryTextPart2: md.render(
        aboutAttributes?.ourStory?.ourStoryTextPart2
      ),
    },
  };

  const introData = {
    title: data?.home?.data?.attributes?.intro_title,
    content: md.render(data?.home?.data?.attributes?.intro ?? "About"),
  };

  delete aboutData.home;

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: { aboutData, introData, layoutData: layoutData },
  };
}
